<template>
    <div class="area-config page-padding">
        <router-view></router-view>
    </div>
</template>
<script>
export default {
    
}
</script>
<style scoped>
.area-config {
    width: 100%;
    height: 100%;
}
</style>